import { Paper, styled } from '@mui/material';

export const StyledBannerWrap = styled(Paper)(() => ({
	position: 'relative',
	gap: '4px',
	margin: '0 !important',
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'flex-end',
	boxShadow: 'none',
	borderRadius: '10px',
	padding: '8px',
	height: '80px',
	maskImage: 'radial-gradient(circle 57px at 78px 90px, transparent 99%, black 100%)',
}));

export const StyledProfileBannerImage = styled('img')({
	objectFit: 'cover',
	position: 'absolute',
	pointerEvents: 'none',
	inset: 0,
	maxWidth: '100%',
	width: '100%',
	height: '100%',
	zIndex: '-1',
	objectPosition: 'center center',
});
